// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// handles Zotero browser plugins - SUM-94523
class Zotero {
   searchResults() {
      const ev = document.createEvent('HTMLEvents')
      ev.initEvent('ZoteroItemUpdated', true, true)
      return document.dispatchEvent(ev)
   }
}

// This service is intended to wrap/talk to external plugins services based on events
class ExternalPluginsService {
   hooks: any
   plugins: any
   static initClass() {
      this.prototype.hooks =
      {searchResults: {}}
  
      // Plugins container
      this.prototype.plugins =
      {zotero: new Zotero}
   }

   constructor() {
      this.on = this.on.bind(this)
      this.fire = this.fire.bind(this)
      for (var plugin in this.plugins) {
         var callback = this.plugins[plugin]
         for (var trigger in this.hooks) {
            if (callback[trigger]) { this.on(trigger, plugin, callback[trigger]) }
         }
      }
   }

   on(message: any, plugin: any, callback: any) {
      return this.hooks[message][plugin] = {callback}
   }

   fire(message: any) {
      // Handle extra arguments to be passed to hooks
      const args: any[] = []
      // @ts-ignore FIXME
      Array.prototype.push.apply(args, arguments)
      args.splice(0, 1)
      for (const plugin in this.hooks[message.name]) {
         this.hooks[message.name][plugin].callback.apply(null, args)
      }
   }
}
ExternalPluginsService.initClass()

angular.module('summonApp.services')
   .service('externalPluginsService', ExternalPluginsService)
